module.exports = __webpack_public_path__ + "public/Icons/cancelReason.svg?ac2f01a2";